import React from 'react';
import { FINANCE_TERMS, itemCostBearer } from '../../utils/operationalFinanceTerms.js';

export default function VisitItemCostBearer({ item, isEditing, onChange, controlId, referenceAvailable = false }) {
    const supplier = item.itemType === 'supplier' || item.item_type === 'supplier';
    const reference = item.supplierRecordMode === 'reference';
    const bearer = reference ? 'reference' : itemCostBearer(item);
    const persisted = Boolean(item.id);
    return <div className="mt-2 text-xs" data-testid={`${controlId}-wrapper`}>
        <label htmlFor={isEditing ? controlId : undefined} className="block mb-1 font-semibold text-slate-700">
            {FINANCE_TERMS.costBearer}
        </label>
        {isEditing ? <select id={controlId} data-testid={controlId} value={bearer}
            onChange={(event) => event.target.value === 'reference'
                ? onChange('supplierRecordMode', 'reference')
                : onChange('customerBillable', event.target.value === 'customer')}
            className="w-full rounded-lg border border-slate-300 bg-white p-2 text-slate-900">
            <option value="customer" disabled={reference && persisted}>العميل</option>
            <option value="workshop" disabled={reference && persisted}>الورشة</option>
            {supplier && <option value="reference" disabled={!reference && (persisted || !referenceAvailable)}>توثيق فقط — دون أثر مالي</option>}
        </select> : <p className="font-semibold text-slate-900" data-testid={controlId}>
            {reference ? 'توثيق فقط — دون أثر مالي' : bearer === 'customer' ? 'العميل' : 'الورشة'}
        </p>}
        <p className="mt-1 text-[11px] leading-5 text-slate-600">
            {reference ? 'للتوثيق فقط؛ لا يدخل إجمالي العميل أو حساب المورد ولا ينشئ قيدًا.' : <>
                {bearer === 'customer' ? 'يُضاف إلى إجمالي العميل.' : 'لا يُضاف إلى إجمالي العميل.'}
                {supplier ? ' شراء فعلي؛ سداد المورد مستقل.' : ''}
            </>}
            {supplier && persisted && isEditing && <span className="block">{reference
                ? 'التوثيق محفوظ. لإنشاء شراء فعلي أضف بندًا جديدًا.'
                : 'شراء محفوظ؛ تحويله إلى توثيق يحتاج مراجعة أثره المالي.'}</span>}
        </p>
    </div>;
}
